export default {
    getStaff(state) {
        return state.staff
    },

    getCategory(state) {
        return state.category
     },
    
    getAllStaffs(state) {
     return state.Allstaffs
    },
            
    getRefreshment(state) {
       return state.Refreshment
    },
    getTicket(state) {
        return state.Ticket

    },
    getMovie(state) {
        return state.Movie

    },
    getCampus(state) {
        return state.Campus

    },
    getLinkedMovies(state) {
        return state.lMovies

    },
    getWatch(state) {
        return state.Watch

    }
}